exports.components = {
  "component---src-layouts-home-js": () => import("./../../../src/layouts/home.js" /* webpackChunkName: "component---src-layouts-home-js" */),
  "component---src-layouts-team-js": () => import("./../../../src/layouts/team.js" /* webpackChunkName: "component---src-layouts-team-js" */),
  "component---src-layouts-text-page-js": () => import("./../../../src/layouts/textPage.js" /* webpackChunkName: "component---src-layouts-text-page-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

